import { Promotions } from "arv-extends/constants";

const APPLY_PROMO_IMAGE = "https://static.omuni.com/ticket_wc.png";

Promotions.APPLY_PROMO_IMAGE = APPLY_PROMO_IMAGE;

export default { APPLY_PROMO_IMAGE };
